(function () {
  function initStickyCta() {
    var sticky = document.querySelector('[data-adv-sticky-cta]');
    if (!sticky) return;
    var trigger = document.querySelector('[data-adv-hero]');
    if (!trigger || !('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio < 0.1) {
          sticky.classList.add('is-visible');
        } else {
          sticky.classList.remove('is-visible');
        }
      });
    }, { threshold: [0, 0.1], rootMargin: '0px 0px -45% 0px' });
    io.observe(trigger);
  }

  function initReadingProgress() {
    var existing = document.querySelector('.adv-progress');
    if (existing) return;
    var bar = document.createElement('div');
    bar.className = 'adv-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var doc = document.documentElement;
      var scrolled = (window.scrollY || doc.scrollTop) - (document.body.clientTop || 0);
      var height = (doc.scrollHeight - doc.clientHeight) || 1;
      var pct = Math.max(0, Math.min(1, scrolled / height));
      bar.style.width = (pct * 100) + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function smoothJumpLinks() {
    document.querySelectorAll('[data-jump]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var sel = link.getAttribute('href') || link.dataset.jump;
        var target = sel && document.querySelector(sel);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initSidebarAutoHide() {
    var sidebar = document.querySelector('.adv-sidebar');
    if (!sidebar || !('IntersectionObserver' in window)) return;
    // Hide sidebar once user enters the closing/final-CTA zone so full-bleed bands center properly
    var triggers = document.querySelectorAll('.adv-cta--band, .adv-text--soft, .adv-disclaimer');
    if (!triggers.length) return;
    var io = new IntersectionObserver(function (entries) {
      var anyVisible = false;
      entries.forEach(function (e) { if (e.isIntersecting) anyVisible = true; });
      if (anyVisible) sidebar.classList.add('is-hidden');
      else sidebar.classList.remove('is-hidden');
    }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
    triggers.forEach(function (t) { io.observe(t); });
  }

  function initAll() {
    initStickyCta();
    initReadingProgress();
    smoothJumpLinks();
    initSidebarAutoHide();
  }

  onReady(initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
